import { defineFetch } from 'resift';

export interface UpdateRoleRequest {
  name?: string;
  description?: string;
  membershipFilter?: any;
}

const makeUpdateRole = defineFetch({
  displayName: 'Update Role',
  make: roleId => ({
    request: (data: UpdateRoleRequest) => ({ http }) =>
      http({
        method: 'PUT',
        route: `/roles/${roleId}`,
        data,
      }),
  }),
});

export default makeUpdateRole;
